import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Cookie } from "lucide-react";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("mc_cookie");
    if (!dismissed) setTimeout(() => setShow(true), 800);
  }, []);

  const act = (val) => {
    localStorage.setItem("mc_cookie", val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 fade-up">
      <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 p-5">
        <div className="flex items-center gap-2 mb-2">
          <Cookie className="h-5 w-5 text-blue-700" />
          <h4 className="font-semibold text-slate-900">This website uses cookies.</h4>
        </div>
        <p className="text-sm text-slate-600 mb-4">
          We use cookies to analyze website traffic and optimize your website experience. By accepting our use of cookies, your data will be aggregated with all other user data.
        </p>
        <div className="flex gap-3">
          <Button variant="outline" className="flex-1 rounded-full" onClick={() => act("declined")}>
            Decline
          </Button>
          <Button className="flex-1 brand-gradient text-white rounded-full" onClick={() => act("accepted")}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
